// ** React Imports
import { useState, useEffect } from "react";

// ** Custom Hooks
import useLocalStorageState from "hooks/useLocalStorageState";

// ##################################

const useWatcherCameraPlayer = ({ reactPlayerRef, playerWrapperRef = {} }) => {
	const videoElement =
		reactPlayerRef?.current && reactPlayerRef?.current.getInternalPlayer();

	const [muted, setMuted] = useState(false);
	const [fullscreen, setFullscreen] = useState(false);

	const [volume, _setVolume] = useLocalStorageState(0.8, "videoVolume");
	const setVolume = (value) => {
		_setVolume(parseFloat(value));
	};

	const toggleMuted = () => {
		setMuted((prevState) => !prevState);
	};

	const changeVolume = (value) => {
		setVolume(value);
		setMuted(value === 0);
	};

	const toggleFullscreen = () => {
		/* MARCIN_P: DZ-1944 - Sprawdzanie czy jest fullscreen i wymuszenie zmiany stanu, ponieważ był bug przy zamykaniu fullscreena "Escape" */

		document.onfullscreenchange = () => {
			if (document.fullscreenElement === null) setFullscreen(false);
		};

		const {
			fullscreenElement,
			webkitFullscreenElement,
			mozFullScreenElement,
			msFullscreenElement,
			fullscreenEnabled,
			webkitFullscreenEnabled,
			mozFullScreenEnabled,
			msFullscreenEnabled,
		} = document;

		// ** Sprawdzenie czy obecnie pełny ekran jest właczony
		if (
			fullscreen &&
			(fullscreenElement ||
				webkitFullscreenElement ||
				mozFullScreenElement ||
				msFullscreenElement)
		) {
			const {
				exitFullscreen,
				webkitExitFullscreen,
				mozCancelFullScreen,
				msExitFullscreen,
			} = document;

			// Mechanizm wyłaczania pełnego ekranu w zależności od przegladarki
			if (exitFullscreen) {
				document.exitFullscreen();
				setFullscreen(false);
			} else if (webkitExitFullscreen) {
				document.webkitExitFullscreen();
				setFullscreen(false);
			} else if (mozCancelFullScreen) {
				document.mozCancelFullScreen();
				setFullscreen(false);
			} else if (msExitFullscreen) {
				document.msExitFullscreen();
				setFullscreen(false);
			}
		}
		// ** Jeśli obecnie pełny ekran nie jest włączony - włączenie pełnego ekranu
		else if (
			!fullscreen &&
			(fullscreenEnabled ||
				webkitFullscreenEnabled ||
				mozFullScreenEnabled ||
				msFullscreenEnabled)
		) {
			const {
				requestFullscreen,
				webkitRequestFullscreen,
				mozRequestFullScreen,
				msRequestFullscreen,
			} = playerWrapperRef?.current || {};

			// ** Mechanizm właczania pełnego ekranu w zależności od przegladarki
			if (requestFullscreen) {
				playerWrapperRef?.current?.requestFullscreen();
				setFullscreen(true);
			} else if (webkitRequestFullscreen) {
				playerWrapperRef?.current?.webkitRequestFullscreen();
				setFullscreen(true);
			} else if (mozRequestFullScreen) {
				playerWrapperRef?.current?.mozRequestFullScreen();
				setFullscreen(true);
			} else if (msRequestFullscreen) {
				playerWrapperRef?.current?.msRequestFullscreen();
				setFullscreen(true);
			}
		}
	};

	useEffect(() => {
		if (videoElement) {
			videoElement.volume = volume;
			// setAudioToSpeaker();
		}
	}, [volume, videoElement]);

	// ##################################

	return {
		muted,
		toggleMuted,
		volume,
		changeVolume,
		fullscreen,
		toggleFullscreen,
	};
};

export default useWatcherCameraPlayer;
